import { gql } from "@apollo/client";

export const CREATE_CUSTOM_BUDGET_MIX = gql`
  mutation CreateCustomBudgetMix(
    $cycleId: String!
    $name: String
    $data: JSONObject
  ) {
    createCustomBudgetMix(cycleId: $cycleId, name: $name, data: $data) {
      budgetMix {
        id
        is_blessed
        is_adopted
        client_setting_id
        client_setting_name
        client_setting_kpi
        is_custom
        pipeline_run_metadata_id
        data {
          aggregated_data {
            spend_data {
              breakdowns {
                key
                value
              }
              spend
              data_column_name
            }
            summary_data {
              kpi_data
              spend
            }
          }
        }
      }
    }
  }
`;

export const ADOPT_BUDGET_MIX = gql`
  mutation AdoptBudgetMix($id: Int!) {
    adoptBudgetMix(id: $id) {
      budgetMix {
        id
        is_blessed
        is_adopted
        client_setting_id
        client_setting_name
        client_setting_kpi
        is_custom
        pipeline_run_metadata_id
        data {
          aggregated_data {
            spend_data {
              breakdowns {
                key
                value
              }
              spend
              data_column_name
            }
            summary_data {
              kpi_data
              spend
            }
          }
        }
      }
    }
  }
`;

export const UNADOPT_BUDGET_MIX = gql`
  mutation UnadoptBudgetMix($id: Int!) {
    unadoptBudgetMix(id: $id) {
      budgetMix {
        id
        is_blessed
        is_adopted
        client_setting_id
        client_setting_name
        client_setting_kpi
        is_custom
        pipeline_run_metadata_id
        data {
          aggregated_data {
            spend_data {
              breakdowns {
                key
                value
              }
              spend
              data_column_name
            }
            summary_data {
              kpi_data
              spend
            }
          }
        }
      }
    }
  }
`;

export const BLESS_BUDGET_MIX = gql`
  mutation BlessBudgetMix($id: Int!, $bless: Boolean!) {
    blessBudgetMix(id: $id, bless: $bless) {
      budgetMix {
        id
        is_blessed
        is_adopted
        client_setting_id
        client_setting_name
        client_setting_kpi
        is_custom
        pipeline_run_metadata_id
        data {
          aggregated_data {
            spend_data {
              breakdowns {
                key
                value
              }
              spend
              data_column_name
            }
            summary_data {
              kpi_data
              spend
            }
          }
        }
      }
    }
  }
`;

export const DELETE_BUDGET_MIX = gql`
  mutation DeleteBudgetMix($id: Int!) {
    deleteBudgetMix(id: $id) {
      budgetMix {
        id
        is_blessed
        is_adopted
        client_setting_id
        client_setting_name
        client_setting_kpi
        is_custom
        pipeline_run_metadata_id
        data {
          aggregated_data {
            spend_data {
              breakdowns {
                key
                value
              }
              spend
              data_column_name
            }
            summary_data {
              kpi_data
              spend
            }
          }
        }
      }
    }
  }
`;
